import React from "react";

import { useDictionary } from "hooks";


export const QuestionLabel = ({
	localConfig,
	onChangeConfig,
	hideLabel,
	isFullColumn,
	isSingleColumnType,
}) => {
	const dictionary = useDictionary("simplifiedBuilder.components.Question.Footer");

	if (hideLabel) {
		return null;
	}
	else if (isFullColumn && isSingleColumnType && !isSingleColumnType.editableLabel) {
		return (
			<label className="ui input" style={{ flexGrow: isFullColumn ? 3 : 1 }}>
				<span>{dictionary.label}</span>
				<input
					type="text"
					aria-label={`Question ${dictionary.label}`}
					value={localConfig?.cayuseShortLabel ?? isSingleColumnType.name}
					disabled
				/>
			</label>
		);
	}
	else {
		const shortLabelKey = localConfig.cayuseShortLabel === "other" ? "cayuseShortLabel2" : "cayuseShortLabel";

		return (
			<label className="ui input" style={{ flexGrow: isFullColumn ? 3 : 1 }}>
				<span>{dictionary.label}</span>
				<input
					type="text"
					value={localConfig[shortLabelKey] || ""}
					maxLength={30}
					aria-label={`Question ${dictionary.label}`}
					onChange={event => onChangeConfig({
						[shortLabelKey]: event.target.value
					})}
				/>
			</label>
		);
	}
};
